export default {
  "HitPaw Online Audio Converter": "HitPaw 온라인 오디오 변환기",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "오디오를 MP3, AAC, FLAC, WMA 등의 형식으로 무료로 변환합니다.",
  'HitPaw Online Image Converter': 'HitPaw 온라인 이미지 변환기',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': '이미지를 JPG, PNG, BMP, TIFF 등의 형식으로 무료로 변환합니다.',
  'HitPaw Online Video Converter': 'HitPaw 온라인 비디오 편집 도구들',
  'Convert videos to any formats as your requirements.': '손쉽게 동영상을 편집하는 데 가장 적합한 도구를 선택하고, 탭하여 시작하세요!',
  'Add More Files': '파일을 더 추가합니다.',
  'Convert to': ' ',
  'Ready': '준비 중',
  'Converting': '변환 중',
  'Video': '비디오',
  'Audio': '오디오',
  'Image': '이미지',
  'Retry': '다시 시도',
  'Download All': '모두 다운로드',
  'Download Desktop': '데스크톱 버전 다운로드',
  'Continue Editing': '편집을 계속합니다.',
  'Convert': '형식 전환',
  'Cut': '잘라내기',
  'Speed': '속도 조정',
  'Crop & Rotate': '자르기 및 회전',
  'Resize': '사이즈 조정',
  'Extract': '추출',
  'Add Music': '음악 추가',
  'Subtitles': '자막 추가',
  'Merge': '합병',
  'Watermark Remover': '워터마크 제거',
  'Add Watermark': '워터마크 추가',
  'Please select a file to use': '{{work}}를/을  사용할 파일을 선택하십시오.',
  'Batch Processing': 'Batch Processing',
};
